import { Row, Col, Image } from "react-bootstrap";
import { motion } from "framer-motion";
import "../assets/styles/top5.css";
import { useEffect, useState } from "react";
import { Top5API } from "../services/userService";

const ordinalEN = (n) => {
  if (n === 1) return "1st";
  if (n === 2) return "2nd";
  if (n === 3) return "3rd";
  return `${n}th`;
};

// دالة لاستخراج أول حرف من الاسم
const getFirstLetter = (name) => {
  if (!name) return "?";
  return name.charAt(0).toUpperCase();
};

export default function TopFive({ currentUserId }) {
  const [Top5, setTop5] = useState([]);

  useEffect(() => {
    async function TopUsers() {
      const res = await Top5API();
      setTop5(res.Top5);
    }
    TopUsers();
  }, []);

  return (
    <div className="top5-wrapper mt-4">
      <Row className="top5-row justify-content-center align-items-end g-3">
        {Top5.map((m, i) => {
          const rank = i + 1;
          const shortName = m.fullName?.split(" ").slice(0, 2).join(" ");
          const isMe = m._id === currentUserId;

          return (
            <Col
              key={i}
              xs={6}
              sm={4}
              md={2}
              className="d-flex justify-content-center"
            >
              <motion.div
                className={`top5-card rank-${rank} ${isMe ? "is-me" : ""}`}
                transition={{ delay: i * 0.1, duration: 0.5, type: "spring" }}
                whileHover={{ scale: 1.05, translateY: -5 }}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
              >
                {isMe && <div className="me-badge">YOU</div>}

                <div className={`avatar-wrap rank-ring-${rank}`}>
                  {m.profileImage ? (
                    <Image
                      src={m.profileImage}
                      roundedCircle
                      alt={m.fullName}
                      className="top5-avatar"
                    />
                  ) : (
                    /* الـ Avatar الذكي بالحرف الأول */
                    <div className={`initial-avatar bg-rank-${rank}`}>
                      {getFirstLetter(m.fullName)}
                    </div>
                  )}

                  {rank === 1 && <span className="badge crown">👑</span>}
                  {rank === 2 && <span className="badge medal silver">🥈</span>}
                  {rank === 3 && <span className="badge medal bronze">🥉</span>}
                </div>

                <div className="top5-info mt-2">
                  <div className="name" title={m.fullName}>
                    {shortName}
                  </div>

                  <div className={`rank-pill pill-${rank}`}>
                    {ordinalEN(rank)} Place
                  </div>
                </div>
              </motion.div>
            </Col>
          );
        })}
      </Row>
    </div>
  );
}

// import { Row, Col, Image } from "react-bootstrap";
    // import { motion } from "framer-motion";
    // import "../assets/styles/top5.css";
    // import { useEffect, useState } from "react";
    // import { Top5API } from "../services/userService";

    // const ordinalEN = (n) => {
    // if (n === 1) return "1st";
    // if (n === 2) return "2nd";
    // if (n === 3) return "3rd";
    // return `${n}th`;
    // };

    // export default function TopFive({ currentUserId }) {
    // const [Top5, setTop5] = useState([]);


    // useEffect(() => {
    //     async function TopUsers() {            
    //     const res = await Top5API();
    //     setTop5(res.Top5);
    //     }
    //     TopUsers();
    // }, []);
        
    // return (
    //     <Row className="top5-row justify-content-center g-2 mt-3">
    //     {Top5.map((m, i) => {
    //         const rank = i + 1;

    //         const shortName = m.fullName?.split(" ").slice(0, 2).join(" ");
    //         const isMe = m._id === currentUserId;

    //         return (
    //         <Col key={i} xs={6} sm={4} md={2} className="d-flex justify-content-center">
    //             <motion.div
    //             className={`top5-card ${rank === 1 ? "leader" : ""} ${isMe ? "is-me" : ""}`}
    //             transition={{ delay: i * 0.05, duration: 0.4 }}
    //             whileHover={{ scale: 1.04 }}
    //             initial={{ opacity: 0, y: 12 }}
    //             animate={{ opacity: 1, y: 0 }}
    //             >
    //                 {isMe && <div className="me-badge">YOU</div>}

    //             <div className="avatar-wrap">
    //                 <Image
    //                 src={
    //                     m.profileImage
    //                     ? m.profileImage
    //                     : m.gender === "MALE"
    //                         ? "/avatars/MALE_avatar.png"
    //                         : "/avatars/FEMALE_avatar.png"
    //                 }
    //                 roundedCircle
    //                 alt={m.fullName}
    //                 className="top5-avatar"
    //                 />

    //                 {rank === 1 && <span className="badge crown">👑</span>}
    //                 {rank === 2 && <span className="badge medal silver">2</span>}
    //                 {rank === 3 && <span className="badge medal bronze">3</span>}
    //             </div>

    //             <div className="top5-info">
    //                 <div className="name" title={m.fullName}>
    //                 {shortName}
    //                 </div>

    //                 <div className="rank-pill">
    //                 {ordinalEN(rank)} Place
    //                 </div>
    //             </div>
    //             </motion.div>
    //         </Col>
    //         );
    //     })}
    //     </Row>
    // );
    // }
